import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useCartContext } from "app/providers/CartProvider";
import { useEffect } from "react";
import CheckoutOverviewFooter from "widgets/checkout/overview-footer";
import CheckoutProducts from "widgets/checkout/overview-products";
import CheckoutWarranty from "widgets/checkout/warranty";

const CheckoutOverview = () => {
  const { cart, containsZakelijkProducts } = useCartContext();
  const { onViewCart, onViewStandardProductCart } = useAnalytics();

  useEffect(() => {
    if (cart.products.length) onViewCart(cart);
    if (cart.standardProducts.length) onViewStandardProductCart(cart);
  }, []);

  const showWarranty =
    !cart.sampleSale && cart.products.length && !containsZakelijkProducts;
  return (
    <>
      <CheckoutProducts />
      {showWarranty ? <CheckoutWarranty /> : <></>}
      <CheckoutOverviewFooter />
    </>
  );
};
export default CheckoutOverview;
